import baseapi from "../baseAPI";

export const RemarkListAPI = async (setRemarks, setLoading, currentPage, perpagedata, setPageCount, filterparams) =>
{
    setLoading(true);

    let searchparam = "";

    if(filterparams !== "" && filterparams !== null && filterparams !== undefined)
    {
        searchparam = `?${filterparams.toString()}`;
    }
    else
    {
        searchparam = "?page=" + currentPage + "&per_page=" + perpagedata;
    }

    try 
    {
        const response = await baseapi.get("/api/team/remarks" + searchparam);

        console.log("Data got successfully", response.data.remarks);
        //let userdata = ['ram', 'shyam', 'rohit'];
        setRemarks(response.data.remarks.data);
        setLoading(false);

        if(response.data.remarks.data.length > 0)
        {
            console.log('Total count====='+response.data.total);
            let pagecount = Math.ceil(response.data.total / perpagedata);

            //console.log('page count====' + pagecount);

            setPageCount(pagecount);
        }

    } 
    catch (error) 
    {
        console.error("Error in user list:", error);
        setLoading(false);
    }

}

export const CallerAPI = async (setCallers) =>
{
    //setLoading(true);

    try 
    {
        const response = await baseapi.get("/api/team/allcallers");

        console.log("Data got successfully", response.data.data);
        //let userdata = ['ram', 'shyam', 'rohit'];
        setCallers(response.data.data);
        //setLoading(false);

    } 
    catch (error) 
    {
        console.error("Error in user list:", error);
        //setLoading(false);
    }

}


